import { useState, useEffect } from "react";

import axios from "axios";
import { Picture } from "./model/picture";

const ListPicture = (): Picture[] => {
  const [pictures, setPictures] = useState<Picture[]>([]);
  const fetchPictures = async () => {
    const response = await axios.get("https://webhook.otera05.xyz/webhook");
    const data = response.data.body;
    const jsonStr = JSON.parse(data);
    setPictures(jsonStr);
  };

  useEffect(() => {
    fetchPictures();
  }, []);

  return pictures;
};

export default ListPicture;
